<script>
import Link from '@/components/lavender/v2/BaseLink.vue'

export default {
  name: 'SupportFooter',
  components: {
    Link,
  },
}
</script>

<template>
  <Link to="merchant.support@tamara.co" class="support-footer">
    <svg-icon name="email" width="16px" height="16px" />
    <span class="tamara-english-regular-4">merchant.support@tamara.co</span>
  </Link>
</template>
